import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import {useAuthContext} from './hooks/useAuthContext'

// pages and components
import Home from './pages/Home'
import Signup from './pages/Signup'
import Login from './pages/Login'
import Navbar from './components/Navbar'
import NewTrip from './pages/NewTrip'
import CurrentTripDetails from './pages/CurrentTripDetails'
import VerifiedRoute from './components/VerifiedRoute'
import UnverifiedRoute from './components/UnverifiedRoute'
import RequestPasswordReset from './pages/RequestPasswordReset'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Settings from './pages/Settings'
import Landing from './pages/Landing'

function App() {
  const {user, isLoading} = useAuthContext()

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <div className="pages">
          <Routes>
            <Route 
              path="/"
              element={!user ? <Landing /> : <Navigate to="/dashboard" />}
            />
            <Route 
              path="/dashboard"
              element={
                <VerifiedRoute user={user} isLoading={isLoading}>
                  <Home />
                </VerifiedRoute>
              } 
            />
            <Route 
              path="/settings"
              element={
                <VerifiedRoute user={user} isLoading={isLoading}>
                    <Settings />
                </VerifiedRoute>
              }
            />
            <Route
              path="/verify-email"
              element={
                <UnverifiedRoute user={user} isLoading={isLoading}>
                    <VerifyEmail />
                </UnverifiedRoute>
              }
            />
            <Route
              path="/request-password-reset"
              element={
                <RequestPasswordReset />
              }
            />
            <Route
              path="/reset-password"
              element={
                <ResetPassword />
              }
            />
            <Route
              path="/new_trip"
              element={
                <VerifiedRoute user={user} isLoading={isLoading}>
                    <NewTrip />
                </VerifiedRoute>
              }
            />
            <Route 
              path="/trip/:trip_id"
              element={
                <VerifiedRoute user={user} isLoading={isLoading}>
                    <CurrentTripDetails />
                </VerifiedRoute>
              }
            />
            <Route 
              path="/login"
              element={!user ? <Login /> : <Navigate to="/dashboard" />}
            />
            <Route 
              path="/signup"
              element={!user ? <Signup /> : <Navigate to="/dashboard" />}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
